(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('indirectSpendCategoryMapping', indirectSpendCategoryMapping);

	indirectSpendCategoryMapping.$inject = ['$scope', '$state', '$experiments'];

	function indirectSpendCategoryMapping($scope, $state, $experiments) {
		var vm = this;
		var reportSettingsName = 'Indirect Spend Category Mapping';
		var meta = {};

		vm.getMeta = getMeta;

		$scope.type = 'customer';
		$scope.reportSettingsName = reportSettingsName;
		$scope.baseReportName = reportSettingsName;

		if (!$experiments.isEnabled('premium-freight')) {
			$state.go('app.site-setup.supply-chain-setup');
		}

		function getMeta() {
			return meta;
		}
	}
})();
